import React, { useEffect, useState } from "react";
import "./HealthDashboard.css";
import VitalCard from "./VitalCard";
export default function HealthDashboard({ faceScan }) {
  useEffect(() => {
    console.log('health dashboard');
    console.log(faceScan);
  })
  return (
    <>
      <div className="container">
        <h2 className="title">Your Results</h2>
        <div className="score-card">
          <div className="circle">
            <span className="score">{faceScan.wellness_score ?? 80}</span>
            <span className="outof">/100</span>
            <p className="label"> 💚 Health Score</p>
          </div>
        </div>
        <div className="grid-2">
          <VitalCard
            title="❤️ Heart Rate"
            value={faceScan?.vitals?.heart_rate ?? 80}
            unit="bpm"
            normalRange="60–100"
            lowRange="≤ 59"
            highRange="≥ 101"
            maxValue={140}
          />
          <VitalCard
            title="🫁 Blood Oxygen"
            value={faceScan?.vitals?.oxy_sat_prcnt ?? 95}
            unit="%"
            normalRange="≥ 95"
            lowRange="< 95"
            maxValue={100}
          />
          {/* stress level */}
          <VitalCard
            title="🧠 Stress Level"
            value={faceScan?.vitals?.hypertension_risk_category ?? "Low"}
            unit=""             // no unit for string value
            normalRange="Low"
            lowRange=""         // not applicable
            highRange="High"
            maxValue={3}        // optional, just for progress bar scaling
          />
          <VitalCard
            title="🌬 Respiration Rate"
            value={faceScan?.vitals?.resp_rate ?? 16}  // default adult RR
            unit="breaths/min"
            normalRange="12–20"
            lowRange="≤ 11"
            highRange="≥ 21"
            maxValue={40}   // maximum for progress bar scaling
          />
          <VitalCard
            title="HbA1c"
            value={faceScan?.metadata?.glucose_info?.hba1c ?? 0}
            unit="%"
            normalRange="4–5.6"
            lowRange=""
            highRange=">5.6"
            maxValue={10}
          />
          <VitalCard
            title="Diabetes Risk"
            value={faceScan?.metadata?.glucose_info?.hba1c_risk ?? ""}
            unit=""
            normalRange="Low"
            highRange="High"
            maxValue={3}
          />
          <VitalCard
            title="Posture"
            value={faceScan?.posture ?? ""}
            unit=""
          />
          <VitalCard
            title="Cardiac Load"
            value={faceScan?.metadata?.cardiovascular?.cardiac_load_category ?? ""}
            unit=""
          />
          <VitalCard
            title="HRV Score"
            value={faceScan?.metadata?.heart_scores?.hrvScore ?? 0}
            unit=""
            normalRange="50–100"
            lowRange="≤ 50"
            highRange="≥ 100"
            maxValue={150}
          />
          <VitalCard
            title="Oxygen Saturation"
            value={faceScan?.vitals?.oxy_sat_prcnt ?? 0}
            unit="%"
            normalRange="≥ 95"
            lowRange="< 95"
            maxValue={100}
          />
          <VitalCard
            title="Blood Pressure"
            value={`${faceScan?.vitals?.bp_sys ?? 0}/${faceScan?.vitals?.bp_dia ?? 0}`}
            unit="mmHg"
          />
        </div>
        {/* Metrics */}
        <div className="grid-2">
          {/*   <Metric title="❤️ Heart Rate"
          value={`${faceScan?.vitals?.heart_rate ?? 80} bpm`}
        /> 
          <Metric title="🫁 Blood Oxygen"
            // value="98%"
            value={`${faceScan?.vitals?.oxy_sat_prcnt ?? 80} %`}
          /> */}
          {/*    <Metric title="🧠 Stress Level"
            value={`${faceScan?.vitals?.hypertension_risk_category ?? 'Low'} `}
          // value="Moderate" 
          /> */}
          {/*    <Metric title="🌬 Respiration Rate"
            value={`${faceScan?.vitals?.resp_rate ?? 0} breaths/min`}
          // value="Moderate" 
          />
          <Metric title="Skin Age" value="28" />
          <Metric title="Hemoglobin"
            value={`${faceScan?.metadata?.glucose_info?.Hemoglobin ?? 0} g/dL`}
          /> */}
          {/*    <Metric title="Hypertension Risk"
            value={`${faceScan?.vitals?.hypertension_risk_category ?? 0} `}
          />
          <Metric title="HbA1c"
            value={`${faceScan?.metadata?.glucose_info?.hba1c ?? 0}% `}
          />
          <Metric title="Diabetes Risk"
            value={`${faceScan?.metadata?.glucose_info?.hba1c_risk ?? ''} `}
          />
          <Metric title="Posture"
            value={`${faceScan?.posture ?? ''} `}
          />
          <Metric title="Cardiac Load"
            value={`${faceScan?.metadata?.cardiovascular?.cardiac_load_category ?? ''} `}
          />
          <Metric title="HRV Score"
            value={`${faceScan?.metadata?.heart_scores?.hrvScore ?? ''} `}
          />
          <Metric title="Oxygen Saturation"
            value={`${faceScan?.vitals?.oxy_sat_prcnt ?? ''}%`}
          />
          <Metric title="Blood Pressure"
            value={`${faceScan?.vitals?.bp_sys}/${faceScan?.vitals?.bp_dia} mmHg`}
          /> */}
        </div>
      </div>
    </>
  );
}
function Insight({ title, value }) {
  return (
    <div className="insight">
      <p className="small">{title}</p>
      <p className="bold">{value}</p>
    </div>
  );
}
function Metric({ title, value }) {
  return (
    <div className="metric">
      <p className="small">{title}</p>
      <p className="bold">{value}</p>
    </div>
  );
}